/**
 * Maps an object key to a human readable string. Used for displaying
 * human readable strings in the UI. If the key is not found, the key
 * itself is returned.
 * @param {object} options - The object containing key-value pairs for mapping.
 * @param options.obj - The object with mappings.
 * @param options.val - The value to map.
 * @returns {string} - The mapped string.
 * @example mapObjectKey({ '1': 'One', '2': 'Two' }, '1') // returns 'One'
 * @example mapObjectKey({ '1': 'One', '2': 'Two' }, '3') // returns '3'
 */
export const mapObjectKey = (obj = {}, key = '') => {
    return obj[key] || key;
};